import Vue from "vue";

const Demande = {
    namespaced: true,
    state: {
        status: '',
        demandes: [],
        demandesMap: [],
        demandesToModer: [],
        currentDemande: {
            id: null,
            marker: '',
            nom: '',
            prenom: '',
            adresse: '',
            route: '',
            adresse_marqueur: '',
            code_postal: '',
            ville: '',
            ident: '',
            etat: '',
            date_deb: '',
            date_fin: '',
            lat: '',
            lon: '',
            date_demande: '',
            email: '',
            raison_sociale: '',
            adresse_beneficiaire: '',
            email_beneficiaire: '',
            nom_beneficiaire: '',
            prenom_beneficiaire: '',
            telephone_beneficiaire: '',
            siret: '',
            telephone: '',
            travaux_arrete: '',
            travaux_autre_travaux: '',
            travaux_benne: '',
            travaux_echafaudage: '',
            travaux_fermeture_rue: '',
            travaux_immatriculation: '',
            travaux_installation_materiaux: '',
            travaux_materiaux: '',
            travaux_mesure_benne: '',
            travaux_mesure_echafaudage: '',
            travaux_mesure_materiaux: '',
            travaux_mesure_nacelle_grue: '',
            travaux_mesure_palissade: '',
            travaux_nacelle_grue: '',
            travaux_nature: '',
            travaux_numero_dossier: '',
            travaux_palissade: '',
            travaux_permis: '',
            travaux_stationnement: '',
            travaux_autre_travaux_precision: '',
            demenagement_immatriculation: '',
            demenagement_installation_materiel: '',
            demenagement_monte_meuble: '',
            demenagement_nacelle_grue: '',
            demenagement_stationnement: '',
            demenagement_autre: '',
            demenagement_autre_precision: '',
            stationnement_immatriculation_1: '',
            stationnement_immatriculation_2: '',
            stationnement_immatriculation_3: '',
            stationnement_motif_demande: '',
            lnk: ''
        },
        demandeToModer: {}
    },
    actions: {
        getDemandes(context, params) {
            return new Promise((resolve, reject) => {
                console.log(params);
                if (typeof params.dd === 'undefined')
                    Vue.axios.get(window.urlapi + "getDemande.php?mode=get&dossier=" + params.dossier + "&platform=mobile").then(
                        response => {
                            context.commit("GETDEMANDES", response.data.data);
                            resolve();
                        }
                    );
                else {
                    Vue.axios.get(window.urlapi + "getDemande.php?mode=getMap&dossier=" + params.dossier + "&platform=mobile&dd=" + params.dd + "&df=" + params.df).then(
                        response => {
                            context.commit("GETDEMANDESMAP", response.data.data);
                            resolve();
                        }
                    );
                }
            })
        },
        getDemande(context, params) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "getDemande.php?mode=getDetails&dossier=" + params.dossier + "&platform=mobile&layername=" + params.layername + "&id_dossier=" + params.id).then(
                    response => {
                        context.commit("SETDEMANDE", response.data.data);
                        resolve();
                    }
                );
            })
        },
        getDemandeByUniqueId(context, params) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "getDemande.php?mode=getDemandeByUniqueId&dossier=" + params.dossier + "&platform=mobile&unique_id=" + params.unique_id).then(
                    response => {
                        context.commit("SETDEMANDE", response.data.data);
                        resolve();
                    }
                );
            })
        },
        setDemande(context, demande) {
            return new Promise((resolve, reject) => {
                context.commit("SETDEMANDE", demande);
                resolve();
            })
        },
        getDemandesToModer(context, form) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('user_id', form.userId);
                formData.append('dossier', JSON.parse(localStorage['env_moder']).dos_cod_t);
                formData.append('platform', 'mobile');

                Vue.axios.post(window.url_ws + "odpModer.php", formData).then(
                    response => {
                        console.log(response);
                        context.commit("GETDEMANDESTOMODER", response.data.data);
                        context.commit('SETSTATUS', response.data.status);
                        resolve();
                    }
                );
            })
        },

        getDemandeToModer(context, form) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('user_id', form.userId);
                formData.append('dossier', JSON.parse(localStorage['env_moder']).dos_cod_t);
                formData.append('layername', form.layername);
                formData.append('platform', 'mobile');
                formData.append('reponse', 'lu');
                formData.append('id_dossier', form.idDossier);

                Vue.axios.post(window.url_ws + "odpModer.php?action=getDetail", formData).then(
                    response => {
                        console.log(response);
                        context.commit("SETDEMANDE", response.data.data);
                        context.commit('SETSTATUS', response.data.status);
                        resolve();
                    }
                );
            })
        },

        setStatus(context, form) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('user_id', form.userId);
                formData.append('status', form.status);
                formData.append('mode', '3');
                formData.append('dossier', JSON.parse(localStorage['env_moder']).dos_cod_t);
                formData.append('platform', 'mobile');

                Vue.axios.post(window.url_ws + "odpModer.php", formData).then(
                    response => {
                        console.log(response);
                        context.commit('SETSTATUS', response.data.status);
                        resolve();
                    }
                );
            })
        },

        updateDemande(context, request) {
            return new Promise((resolve, reject) => {
                let form = new FormData();
                form.append("gid", request.id);
                form.append("marker", request.marker);
                form.append("nom", request.nom);
                form.append("prenom", request.prenom);
                form.append("adresse", request.adresse);
                if (request.etat === 3) form.append('etat', '3');
                form.append("code_postal", request.code_postal);
                form.append("ville", request.ville);
                form.append("email", request.email);
                form.append("raison_sociale", request.raison_sociale);
                form.append("siret", request.siret);
                form.append("telephone", request.telephone);

                switch (request.marker) {
                    case 'odp_stationnement':
                        form.append("dates_stationnement_debut", request.date_deb);
                        form.append("dates_stationnement_fin", request.date_fin);
                        form.append("immatriculation_1", request.stationnement_immatriculation_1);
                        form.append("immatriculation_2", request.stationnement_immatriculation_2);
                        form.append("immatriculation_3", request.stationnement_immatriculation_3);
                        form.append("motif_demande_stationnement", request.stationnement_motif_demande);
                        break;
                    case 'odp_demenagement':
                        form.append("dates_demenagement_debut", request.date_deb);
                        form.append("dates_demenagement_fin", request.date_fin);
                        form.append("adresse_beneficiaire", request.adresse_beneficiaire);
                        form.append("email_beneficiaire", request.email_beneficiaire);
                        form.append("nom_beneficiaire", request.nom_beneficiaire);
                        form.append("prenom_beneficiaire", request.prenom_beneficiaire);
                        form.append("telephone_beneficiaire", request.telephone_beneficiaire);

                        form.append("immatriculation_demenagement", request.demenagement_immatriculation);
                        form.append("installation_materiel", request.demenagement_installation_materiel);
                        form.append("monte_meuble", request.demenagement_monte_meuble);
                        form.append("nacelle_grue", request.demenagement_nacelle_grue);
                        form.append("stationnement_demenagement", request.demenagement_stationnement);
                        form.append("autre", request.demenagement_autre);
                        form.append("autre_precision", request.demenagement_autre_precision);
                        break;
                    case 'odp_travaux':
                        form.append("dates_travaux_debut", request.date_deb);
                        form.append("dates_travaux_fin", request.date_fin);
                        form.append("adresse_beneficiaire", request.adresse_beneficiaire);
                        form.append("email_beneficiaire", request.email_beneficiaire);
                        form.append("nom_beneficiaire", request.nom_beneficiaire);
                        form.append("prenom_beneficiaire", request.prenom_beneficiaire);
                        form.append("telephone_beneficiaire", request.telephone_beneficiaire);

                        form.append("arrete", request.travaux_arrete);
                        form.append("autre_travaux", request.travaux_autre_travaux);
                        form.append("benne", request.travaux_benne);
                        form.append("echafaudage", request.travaux_echafaudage);
                        form.append("fermeture_rue", request.travaux_fermeture_rue);
                        form.append("immatriculation_travaux", request.travaux_immatriculation);
                        form.append("installation_materiaux", request.travaux_installation_materiaux);
                        form.append("materiaux", request.travaux_materiaux);
                        form.append("mesure_benne", request.travaux_mesure_benne);
                        form.append("mesure_echafaudage", request.travaux_mesure_echafaudage);
                        form.append("mesure_materiaux", request.travaux_mesure_materiaux);
                        form.append("mesure_nacelle_grue", request.travaux_mesure_nacelle_grue);
                        form.append("mesure_palissade", request.travaux_mesure_palissade);
                        form.append("nacelle_grue_travaux", request.travaux_nacelle_grue);
                        form.append("nature_travaux", request.travaux_nature);
                        form.append("numero_dossier", request.travaux_numero_dossier);
                        form.append("palissade", request.travaux_palissade);
                        form.append("permis", request.travaux_permis);
                        form.append("stationnement_travaux", request.travaux_stationnement);
                        form.append("autre_travaux_precision", request.travaux_autre_travaux_precision);
                        break;
                }

                Vue.axios.post(window.url_ws + "getDemande.php?mode=setForm&dossier=" + JSON.parse(localStorage['env_assign']).dos_cod_t, form).then(
                    response => {
                        if (response.data.success) {
                            Vue.prototype.$awn.success(
                                'Votre demande a été modifiée avec succès'
                            );
                            context.commit("SETDEMANDE", request);
                        }
                        resolve();
                    }
                );
            })
        },

        duplicateDemande(context, request) {
            let form = new FormData();

            form.append("gid", request.id);
            form.append("marker", request.marker);

            switch (request.marker) {
                case 'odp_stationnement':
                    form.append("dates_stationnement_debut", request.date_deb);
                    form.append("dates_stationnement_fin", request.date_fin);
                    break;
                case 'odp_demenagement':
                    form.append("dates_demenagement_debut", request.date_deb);
                    form.append("dates_demenagement_fin", request.date_fin);
                    break;
                case 'odp_travaux':
                    form.append("dates_travaux_debut", request.date_deb);
                    form.append("dates_travaux_fin", request.date_fin);
                    break;
            }

            Vue.axios.post(window.url_ws + "getDemande.php?mode=duplicateDemande&dossier=" + JSON.parse(localStorage['env_assign']).dos_cod_t, form).then(
                response => {
                    if (response.data.success) {
                        Vue.prototype.$awn.success(
                            'Votre demande de prolongation a été ajoutée avec succès'
                        );
                    }
                }
            );
        }
    },
    mutations: {
        GETDEMANDES: (state, demandes) => {
            state.demandes = demandes
        },
        GETDEMANDESMAP: (state, demandes) => {
            state.demandesMap = demandes
        },
        SETDEMANDE: (state, demande) => {
            state.currentDemande = demande
        },
        GETDEMANDESTOMODER: (state, demandesToModer) => {
            state.demandesToModer = demandesToModer
        },
        SETSTATUS: (state, status) => {
            state.status = status;
        }
    },
    getters: {
        demandes: state => {
            return state.demandes;
        },
        demandesMap: state => {
            return state.demandesMap;
        },
        currentDemande: state => {
            return state.currentDemande;
        },
        demandesToModer: state => {
            return state.demandesToModer;
        },
        status: state => {
            return state.status;
        }
    }
}

export default Demande;